import type { CrawlerFormData } from "pages/crawler/types";
import { crawlerFormToCostProject, formatRequiresAutoparse } from "pages/crawler/utils/crawlerFormUtils";
import { useProjectCostEstimate } from "hooks/useProjectCostEstimate";
import { useLegacyRate } from "hooks/useLegacyRate";

export const useCrawlerCostEstimate = (formValues: CrawlerFormData) => {
  const { cost, isLoading } = useProjectCostEstimate(
    crawlerFormToCostProject(formValues),
    "api",
    { debounceMs: 400 }
  );

  // Legacy-rate message (ENG-1112) for the "URL to Crawl" domain and the crawler's pricing options.
  const legacyStandardCredits = useLegacyRate(
    formValues.url,
    {
      render: formValues.renderJs,
      premium: formValues.residentialIps,
      ultraPremium: formValues.advancedBypassing,
      // Editing a JSON crawler gives autoparse: true with no format (the backend stores it that way).
      autoparse: formValues.autoparse || formatRequiresAutoparse(formValues.outputFormat),
    },
    { debounceMs: 400 }
  );

  return { costPerRequest: cost ?? 1, costLoading: isLoading, legacyStandardCredits };
};
